import request from '@/utils/request'

let Rescue_serviceApi = {

  /*救援服务列表*/
  list(data) {
    return request._post('/shop/plus.rescue_service.Index/index', data);
},
/*添加救援服务*/
add(data) {
    return request._post('/shop/plus.rescue_service.Index/add', data);
},
/*修改救援服务*/
edit(data) {
    return request._post('/shop/plus.rescue_service.Index/edit', data);
},
/*删除救援服务*/
del(data) {
    return request._post('/shop/plus.rescue_service.Index/del', data);
},
/*救援服务详情*/
detail(data) {
  return request._post('/shop/plus.rescue_service.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.rescue_service.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.rescue_service.Setting/getSetting', data, errorback);
    },
    // 审核
 passCanel(data) {
    return request._post('/shop/plus.rescue_service.Index/passCanel', data);
  },
}
export default Rescue_serviceApi;



// WEBPACK FOOTER //
// ./src/api/rescue_service.js